var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{attrs:{"md":"12"}},[_c('button',{class:[
      'modal-type-card',
      {
        'modal-type-card--with-hover-effect': _vm.hasHoverEffect,
        'modal-type-card--is-selected': _vm.isSelected,
      },
    ],on:{"click":() => _vm.$emit('click')}},[(false)?_c('i',{class:_vm.icon}):_vm._e(),_c('div',[_c('p',{staticClass:"modal-type-card__title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"modal-type-card__description mb-0"},[_vm._v(_vm._s(_vm.description))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }